/**
 * @description 全局Model answerModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import {
  APIS,
  PageableResultAnswerInfo,
  AnswerVO,
  CommentInfo,
  ParamsanswerAnswerIdAgreeUsingPost,
  ParamsanswerQuestionIdUsingGet,
  ParamscommentsIdUsingDelete,
  ParamsBodyanswerCommentUsingPost,
  ParamsBodyanswerPublishUsingPost,
  AnswerInfo
} from '@src/services';
import { message } from 'antd';
import { TkitUtils as Utils } from '@tkit/types';
import { IntegralMessage } from '@src/features/common/components';
import { ARTICLES_NAV_KEY_ARTICLE, ARTICLES_NAV_KEY_QUESTION } from '@src/utils/constant/articles';
import { NETWORK_ERROR_TIP } from '@src/utils/constant/common';

export interface State {
  answerListData: PageableResultAnswerInfo;
  askInfoAnswerLoad: boolean;
}

export const answerModelState: State = {
  answerListData: {},
  askInfoAnswerLoad: true
};

const model = createModel({
  state: answerModelState,
  namespace: 'answerModel',
  reducers: {
    deleteAnswerList: (state, action: Tction<{ id: number }>) => {
      const { answerListData } = state;
      return {
        ...state,
        answerListData: {
          ...state.answerListData,
          list: state.answerListData.list?.filter(item => item.answerId !== action.payload.id),
          total: answerListData.total && answerListData.total > 1 ? answerListData.total - 1 : 0
        }
      };
    },
    updateAnswerList: (state, action: Tction<PageableResultAnswerInfo>) => {
      return {
        ...state,
        answerListData: {
          ...action.payload
        }
      };
    },
    updateMoreComment: (state, action: Tction<PageableResultAnswerInfo>) => {
      const {
        answerListData: { list: oldList = [] }
      } = state;
      const { list: newList = [] } = action.payload;
      const answerListData = {
        ...action.payload,
        list: [...oldList, ...newList]
      };

      return {
        ...state,
        answerListData
      };
    },
    updateAnswerListData: (
      state,
      action: Tction<{ answerId: number; type: number; agreeCount: number }>
    ) => {
      const {
        answerListData: oldData,
        answerListData: { list = [] }
      } = state;
      const { answerId, type, agreeCount } = action.payload;
      const answerListData = {
        ...oldData,
        list: list.map(item => {
          if (item.answerId === answerId) {
            return {
              ...item,
              agreeStatus: type,
              agreeCount
            };
          } else {
            return item;
          }
        })
      };
      return {
        ...state,
        answerListData
      };
    },
    updateAnswerListAdopt: (state, action: Tction<{ answerId: number }>) => {
      return {
        ...state,
        answerListData: {
          ...state.answerListData,
          list:
            (state.answerListData.list &&
              state.answerListData.list.map(item => {
                return {
                  ...item,
                  isAdopt: action.payload.answerId === item.answerId
                };
              })) ||
            []
        }
      };
    },
    /**
     * @description 设置答案列表loading
     */
    setAnswerListLoad: (state, action: Tction<boolean>) => {
      return {
        ...state,
        askInfoAnswerLoad: action.payload
      };
    },
    /**
     * @description 添加一级评论
     */
    addAnswerCom: (state, action: Tction<{ comment: CommentInfo; answerId: number }>) => {
      const { comment, answerId } = action.payload;
      const {
        answerListData: oldData,
        answerListData: { list = [] }
      } = state;

      const answerListData = {
        ...oldData,
        list: list.map(item => {
          if (item.answerId === answerId) {
            const { allCommentsForAnswer = [] } = item;
            return {
              ...item,
              allCommentsForAnswer: [comment, ...allCommentsForAnswer]
            };
          } else {
            return item;
          }
        })
      };

      return {
        ...state,
        answerListData
      };
    },
    /**
     * @description 删除一级评论
     */
    removeAnswerCom: (state, action: Tction<{ comId: number; answerId: number }>) => {
      const { comId, answerId } = action.payload;
      const {
        answerListData: oldData,
        answerListData: { list = [] }
      } = state;

      const answerListData = {
        ...oldData,
        list: list.map(item => {
          if (item.answerId === answerId) {
            const { allCommentsForAnswer = [] } = item;
            return {
              ...item,
              allCommentsForAnswer: allCommentsForAnswer.filter(com => com.id !== comId)
            };
          } else {
            return item;
          }
        })
      };

      return {
        ...state,
        answerListData
      };
    },
    /**
     * @description 一级评论设置是否点赞
     */
    setAskComIsThumb: (
      state,
      action: Tction<{ isThumb: boolean; answerId: number; comId: number }>
    ) => {
      const { isThumb, answerId, comId } = action.payload;
      const {
        answerListData: oldData,
        answerListData: { list = [] }
      } = state;

      const answerListData = {
        ...oldData,
        list: list.map(item => {
          if (item.answerId === answerId) {
            const { allCommentsForAnswer = [] } = item;
            return {
              ...item,
              allCommentsForAnswer: allCommentsForAnswer.map(com => {
                if (com.id === comId) {
                  const { thumbs = 0 } = com;
                  return {
                    ...com,
                    hasLiked: isThumb,
                    thumbs: isThumb ? thumbs + 1 : thumbs - 1
                  };
                }
                return com;
              })
            };
          } else {
            return item;
          }
        })
      };

      return {
        ...state,
        answerListData
      };
    },
    /**
     * @description 添加二级评论
     */
    toAddAskSecondCom: (
      state,
      action: Tction<{ newCom: CommentInfo; answerId: number; comId: number }>
    ) => {
      const { answerId, comId, newCom } = action.payload;
      const {
        answerListData: oldData,
        answerListData: { list = [] }
      } = state;

      const answerListData = {
        ...oldData,
        list: list.map(item => {
          if (item.answerId === answerId) {
            const { allCommentsForAnswer = [] } = item;
            return {
              ...item,
              allCommentsForAnswer: allCommentsForAnswer.map(com => {
                if (com.id === comId) {
                  const { subCommentList = [] } = com;
                  return {
                    ...com,
                    subCommentList: [newCom, ...subCommentList]
                  };
                }
                return com;
              })
            };
          } else {
            return item;
          }
        })
      };

      return {
        ...state,
        answerListData
      };
    },
    /**
     * @description 删除二级评论
     */
    toRemoveAskSecondCom: (
      state,
      action: Tction<{ answerId: number; comId: number; secondId: number }>
    ) => {
      const { answerId, comId, secondId } = action.payload;
      const {
        answerListData: oldData,
        answerListData: { list = [] }
      } = state;

      const answerListData = {
        ...oldData,
        list: list.map(item => {
          if (item.answerId === answerId) {
            const { allCommentsForAnswer = [] } = item;
            return {
              ...item,
              allCommentsForAnswer: allCommentsForAnswer.map(com => {
                if (com.id === comId) {
                  const { subCommentList = [] } = com;
                  return {
                    ...com,
                    subCommentList: subCommentList.filter(ele => ele.id !== secondId)
                  };
                }
                return com;
              })
            };
          } else {
            return item;
          }
        })
      };

      return {
        ...state,
        answerListData
      };
    },
    /**
     * @description 设置子评论
     */
    setAskSecondComList: (
      state,
      action: Tction<{ answerId: number; comId: number; subCommentList: CommentInfo[] }>
    ) => {
      const { answerId, comId, subCommentList } = action.payload;
      const {
        answerListData: oldData,
        answerListData: { list = [] }
      } = state;

      const answerListData = {
        ...oldData,
        list: list.map(item => {
          if (item.answerId === answerId) {
            const { allCommentsForAnswer = [] } = item;
            return {
              ...item,
              allCommentsForAnswer: allCommentsForAnswer.map(com => {
                if (com.id === comId) {
                  return {
                    ...com,
                    subCommentList
                  };
                }
                return com;
              })
            };
          } else {
            return item;
          }
        })
      };

      return {
        ...state,
        answerListData
      };
    },
    /**
     * @description 添加新回答
     */
    addNewAnswer: (state, action: Tction<AnswerInfo>) => {
      const {
        answerListData: oldData,
        answerListData: { list = [], total = 0 }
      } = state;

      const answerListData = {
        ...oldData,
        list: [action.payload, ...list],
        total: total + 1
      };

      return {
        ...state,
        answerListData
      };
    }
  },
  effects: {
    /**
     * 获取回答列表
     */
    *doGetAnswerList(
      { tPut, tCall, select },
      action: Tction<{ params: ParamsanswerQuestionIdUsingGet }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const data: Utils.GetROA<typeof APIS.AnswerApi.answerQuestionIdUsingGet> = yield tCall(
        APIS.AnswerApi.answerQuestionIdUsingGet,
        params
      );

      if (data.code === 0 && data.result) {
        yield tPut(model.actions.updateAnswerList, data.result);
        yield tPut(model.actions.setAnswerListLoad, false);
      }
    },
    /**
     * @description 获取更多评论
     */
    *getMoreCommentAsync(
      { tPut, tCall, select },
      action: Tction<{ params: ParamsanswerQuestionIdUsingGet; callback?: () => void }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const data: Utils.GetROA<typeof APIS.AnswerApi.answerQuestionIdUsingGet> = yield tCall(
        APIS.AnswerApi.answerQuestionIdUsingGet,
        params
      );

      if (data.code === 0 && data.result?.list?.length) {
        yield tPut(model.actions.updateMoreComment, data.result);
        callback && callback();
      }
    },
    /**
     * 发布1级评论
     */
    *addAnswerComment(
      { tPut, tCall },
      action: Tction<{
        params: ParamsBodyanswerCommentUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const {
        params,
        params: { answerId }
      } = action.payload;
      const res: Utils.GetROA<typeof APIS.AnswerApi.answerCommentUsingPost> = yield tCall(
        APIS.AnswerApi.answerCommentUsingPost,
        params
      );

      if (res.code === 0 && res.result && answerId) {
        message.success('评论成功');
        yield tPut(model.actions.addAnswerCom, { comment: res.result, answerId });
      } else {
        message.error(res.message);
      }
    },
    /**
     * 删除1级评论
     */
    *removeAnswerComment(
      { tPut, tCall },
      action: Tction<{
        params: ParamscommentsIdUsingDelete;
        answerId: number;
      }>
    ): Iterator<{}, any, any> {
      const { params, answerId } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsIdUsingDelete> = yield tCall(
        APIS.CommentApi.commentsIdUsingDelete,
        params
      );

      if (res.code === 0) {
        message.success('删除成功');
        yield tPut(model.actions.removeAnswerCom, { answerId, comId: params.id });
      }
    },
    /**
     * 一级评论点赞
     */
    *doThumbsComment(
      { tPut, tCall, select },
      action: Tction<{
        params: ParamsanswerAnswerIdAgreeUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const {
        params,
        params: { answerId, type }
      } = action.payload;
      const res: Utils.GetROA<typeof APIS.AnswerApi.answerAnswerIdAgreeUsingPost> = yield tCall(
        APIS.AnswerApi.answerAnswerIdAgreeUsingPost,
        action.payload.params
      );
      const toastMessageMap = {
        0: '取消成功',
        1: '点赞成功',
        2: '反对成功'
      };

      if (res.code === 0) {
        yield tPut(model.actions.updateAnswerListData, {
          answerId,
          type,
          agreeCount: res.result?.agreeCount || 0
        });
        res.message && IntegralMessage(res.message, toastMessageMap[type]);
      }
    },
    *doChangeAnswerListItemAdopt(
      { tPut, tCall },
      action: Tction<{
        answerId: number;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateAnswerListAdopt, {
        answerId: action.payload.answerId
      });
    },
    /**
     * @description 获取更过答案
     */
    *getMoreAnswer(
      { tPut, tCall },
      action: Tction<{
        answerId: number;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateAnswerListAdopt, {
        answerId: action.payload.answerId
      });
    },
    /**
     * @description 一级评论点赞
     */
    *askFirstComTumb(
      { tPut, tCall },
      action: Tction<{
        id: number;
        answerId: number;
      }>
    ): Iterator<{}, any, any> {
      const { id, answerId } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsThumbUpIdUsingPost> = yield tCall(
        APIS.CommentApi.commentsThumbUpIdUsingPost,
        { id }
      );

      if (res.code === 0) {
        yield tPut(model.actions.setAskComIsThumb, { isThumb: true, answerId, comId: id });
        message.success('点赞成功');
      } else {
        message.error('点赞失败');
      }
    },
    /**
     * @description 一级评论取消
     */
    *askFirstComTumbCancel(
      { tPut, tCall },
      action: Tction<{
        id: number;
        answerId: number;
      }>
    ): Iterator<{}, any, any> {
      const { id, answerId } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsThumbUpIdUsingDelete> = yield tCall(
        APIS.CommentApi.commentsThumbUpIdUsingDelete,
        { id }
      );

      if (res.code === 0) {
        yield tPut(model.actions.setAskComIsThumb, { isThumb: false, answerId, comId: id });
        message.success('取消赞成功');
      } else {
        message.error('取消赞失败');
      }
    },
    /**
     * @description 添加二级评论
     */
    *addAskSecondCom(
      { tPut, tCall },
      action: Tction<{
        params: ParamsBodyanswerCommentUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const {
        params,
        params: { answerId, commentId }
      } = action.payload;
      const res: Utils.GetROA<typeof APIS.AnswerApi.answerCommentUsingPost> = yield tCall(
        APIS.AnswerApi.answerCommentUsingPost,
        params
      );

      if (res.code === 0 && res.result && commentId && answerId) {
        yield tPut(model.actions.toAddAskSecondCom, {
          newCom: res.result,
          comId: commentId,
          answerId
        });
        message.success('评论成功');
      } else {
        message.error(res.message);
      }
    },
    /**
     * @description 删除二级评论
     */
    *removeAskSecondCom(
      { tPut, tCall },
      action: Tction<{
        params: ParamscommentsIdUsingDelete;
        answerId: number;
        parentId: number;
      }>
    ): Iterator<{}, any, any> {
      const { params, parentId, answerId } = action.payload;
      const res: Utils.GetROA<typeof APIS.CommentApi.commentsIdUsingDelete> = yield tCall(
        APIS.CommentApi.commentsIdUsingDelete,
        params
      );

      if (res.code === 0) {
        yield tPut(model.actions.toRemoveAskSecondCom, {
          answerId,
          comId: parentId,
          secondId: params.id
        });
        message.success('删除成功');
      } else {
        message.error('删除失败');
      }
    },
    /**
     * @description 发布新答案
     */
    *publishNewAnswer(
      { tPut, tCall },
      action: Tction<{
        params: ParamsBodyanswerPublishUsingPost;
        callback?: (res: AnswerVO) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.AnswerApi.answerPublishUsingPost> = yield tCall(
        APIS.AnswerApi.answerPublishUsingPost,
        params
      );

      if (res.code === 0 && res.result) {
        yield tPut(model.actions.addNewAnswer, res.result);
        callback && callback(res.result);
        message.success('回答成功');
      } else {
        message.error('回答失败');
      }
    },
    /**
     * @description 删除答案
     */
    *deleteAnswer(
      { tPut, tCall },
      action: Tction<{ params: { answerId: number } }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const res: Utils.GetROA<typeof APIS.AdminApi.deleteQuestion> = yield tCall(
        APIS.AdminApi.deleteAnswer,
        params
      );
      const { code } = res;
      if (code === 0) {
        yield tPut(model.actions.deleteAnswerList, { id: params.answerId });
        message.success('删除成功');
      } else {
        message.error(res.message);
      }
    }
  }
});

export default model;
